import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Checkbox, CircularProgress, FormControlLabel } from "@material-ui/core";
import ActionDialog from "../../ActionDialog";
import { editAgreementManagerMonthlyCommission } from "../../../../actions";
import { normalizePercentValue } from "../../../../util";
import { useManagementAction } from "../../../../hooks/useManagementAction";
import LocaleNumberField from "../../LocaleNumberField";

const ChangeManagerMonthlyCommission = ({ open, handleCloseDialog, user, fetchUser }) => {
  const { handleManagementAction } = useManagementAction();

  const initialManagerMonthlyCommission = normalizePercentValue(user?.contractAgent?.managerMonthlyCommission);
  const defaultManagerMonthlyCommission = normalizePercentValue(user.contractAgent.contractAgentClass?.managerMonthlyCommission);
  const [loading, setLoading] = useState(false);
  const [managerMonthlyCommission, setManagerMonthlyCommission] = useState(() => initialManagerMonthlyCommission);
  const [useDefault, setUseDefault] = useState(user.contractAgent.defaultManagerMonthlyCommission);

  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const onFinish = () => {
    if (!isMountedRef.current) return;

    setLoading(false);
    handleCloseDialog();
  };

  const handleSubmit = async () => {
    let newManagerMonthlyCommission = null;
    if (managerMonthlyCommission !== null) {
      newManagerMonthlyCommission = managerMonthlyCommission / 100;
    }

    setLoading(true);
    await handleManagementAction({
      body: { editedUserId: user.id, managerMonthlyCommission: newManagerMonthlyCommission },
      managementAction: editAgreementManagerMonthlyCommission,
      onComplete: fetchUser,
      onFinish,
      successMessage: "app.edit.sucesfully",
    });
  };

  const handleClose = () => {
    setManagerMonthlyCommission(initialManagerMonthlyCommission);
    handleCloseDialog();
  };

  useEffect(() => {
    setManagerMonthlyCommission(useDefault ? null : initialManagerMonthlyCommission);
  }, [useDefault, initialManagerMonthlyCommission]);

  return (
    <ActionDialog
      title="app.edit"
      open={open}
      onAccept={handleSubmit}
      onClose={handleClose}
      textConfirm="app.edit"
      maxWidth="xs"
      disableConfirmButton={loading || managerMonthlyCommission === ""}
      textToConfirmation={"app.confirm.changeManagementCommission"}
    >
      <LocaleNumberField
        defaultValue={defaultManagerMonthlyCommission}
        disabled={loading || useDefault}
        endAdornment="%"
        fullWidth
        label={"app.manager.managerMonthlyCommission"}
        min={0}
        max={100}
        value={managerMonthlyCommission}
        setValue={setManagerMonthlyCommission}
      />
      <FormControlLabel
        disabled={loading}
        control={
          <Checkbox
            checked={useDefault}
            onChange={() => setUseDefault((prev) => !prev)}
            color="primary"
          />
        }
        label={<FormattedMessage id="app.manager.useDefault" />}
      />
      {loading && (
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <CircularProgress />
        </div>
      )}
    </ActionDialog>
  );
};
export default ChangeManagerMonthlyCommission;
